import TourTooltip from 'elements/tooltip/TourTooltip'
import { TourConfigType } from 'persistentContent/tours/types'
import { useTranslate } from 'ra-core'
import { FC } from 'react'

const StepTooltip: FC = (props) => {
  const translate = useTranslate()
  return (
    <TourTooltip
      title={translate('Custom View Options')}
      subtext={translate('Customise your list display for a view that works for you.')}
      {...props}
    />
  )
}

const ProjectListSort: TourConfigType = {
  spotlights: [{ targetId: 'Project-List-Settings-Section-Inner' }],
  tooltips: [
    {
      targetId: 'Project-List-Settings-Section-Inner',
      placement: 'left',
      component: StepTooltip,
    },
  ],
}

export default ProjectListSort
